import React, { useContext, useEffect } from 'react'
import { useBooks } from '@hooks/useBooks'
import {
  CARD_SIZES,
  HEADING_TYPE,
  TEXT_SIZES,
  DIVIDER_SIZE,
  BOOK_LIST_TYPES,
} from '@helpers/constants'
import Text from '@components/Text'
import Loader from '@components/Loader'
import BookList from '@components/BookList'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
import { getSubjectTextClass } from '@helpers/subject'
import { useFilteredItems } from '@hooks/useFilteredItems'
import { setFilteredItems } from '@state/actions/filtersActions'
import { AppContext } from '@state/context'
import { useLibraryBooks } from '@hooks/useLibraryBooks'

const LibraryBooks = () => {
  const [, dispatch] = useContext(AppContext)
  const {
    books,
    error: booksError,
    isLoading: isLoading,
  } = useLibraryBooks()
  const filteredBooks = useFilteredItems(books)

  // Grouped by subject
  const booksBySubject = filteredBooks.reduce((acc, item) => {
    if (item.subject.id in acc) {
      acc[item.subject.id].items.push(item)
    } else {
      acc[item.subject.id] = {
        subject: item.subject,
        items: [item],
      }
    }
    return acc
  }, {})

  useEffect(() => {
    dispatch(setFilteredItems([...books]))
  }, [books])

  return (
    <div className={'flex flex-col items-center justify-center'}>
      {booksError && <Text>Error Loading Books</Text>}
      {!isLoading && !filteredBooks.length && <Text>Kunde inte hitta några böcker</Text>}

      {Object.entries(booksBySubject).map(([subjectId, {subject, items}]) => (
        <div key={subjectId} className={'w-full'}>
          <Heading
            extraClasses={getSubjectTextClass(subject.slug, 'dark')}
            size={TEXT_SIZES.XXLARGE}
            headingLevel={HEADING_TYPE.H1}
          >
            {subject.name}
          </Heading>
          <Divider size={DIVIDER_SIZE.SMALL} />
          <BookList
            type={BOOK_LIST_TYPES.LIBRARY}
            gridCols={4}
            items={items}
            cardSize={CARD_SIZES.SMALL}
          />
          <Divider size={DIVIDER_SIZE.MEDIUM} />
        </div>
      ))}
      {isLoading && <Loader />}
    </div>
  )
}

export default LibraryBooks
